import defaultsOrg from "../defaults"

const styles = (defaults: typeof defaultsOrg) => ({
    medium: {
        fontWeight: defaults.fontWeights.medium,
    },
})

export default styles
